import SalesRoute from "./Voucher/Components/Sales/Routes";
import VoucherRoute from "./Voucher/Routes";
import AccountRoute from "./Account/Routes";
import InventoryRoute from "./Inventory";
import ProductGroup from "./Inventory/ProductGroup/Routes";
import ReportRoute from "./Reports/Routes";
import SettingsRoute from "./Settings/Routes";
import NoteSheet from "./Account/NoteSheet/Routes";
import PreSanction from "./Account/PreSanction/Routes";
import UserRation from "./UserRation/Routes";

export default [...VoucherRoute, ...AccountRoute, ...InventoryRoute, ...ReportRoute, ...SettingsRoute, ...ProductGroup, ...NoteSheet, ...PreSanction, ...UserRation, ...SalesRoute];
